import { makeAutoObservable } from "mobx";
import { ContextMenuOption } from "../components/ContextMenu/ContextMenu";

interface ContextMenuPosition {
  x: number;
  y: number;
}

export type ContextMenuPlacement =
  | "top-start"
  | "top-end"
  | "bottom-start"
  | "bottom-end";

export type ContextMenuAnchorRect = {
  left: number;
  right: number;
  top: number;
  bottom: number;
  width: number;
  height: number;
};

export type ContextMenuConfig = {
  placement?: ContextMenuPlacement;
  anchorRect?: ContextMenuAnchorRect;
  widthPx?: number;
  maxWidthPx?: number;
};

class ContextMenuStoreInstance {
  position: ContextMenuPosition | null = null;
  options: ContextMenuOption[] = [];
  config: ContextMenuConfig | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  show(x: number, y: number, options: ContextMenuOption[], config?: ContextMenuConfig) {
    this.position = { x, y };
    this.options = options;
    this.config = config ?? null;
  }

  hide() {
    this.position = null;
    this.config = null;
  }

  reset() {
    this.position = null;
    this.options = [];
    this.config = null;
  }
}

const ContextMenuStore = new ContextMenuStoreInstance();

export { ContextMenuStore };
